/*eslint-disable*/
import {
  TextField,
  withStyles,
  InputAdornment,
  IconButton
} from "@material-ui/core";
import React from "react";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

const styles = theme => ({
  textField: {
    width: "100%",
    marginTop: 0,
    marginBottom: 0
  }
});

class FormInputClass extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = event => {
    event.preventDefault();

    if (this.props.input.onChange) {
      this.props.input.onChange(event);
      this.props.input.onBlur(event);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.meta.touched ||
      nextProps.input.value !== this.props.input.value ||
      nextProps.p_value !== this.props.p_value
    ) {
      this.forceUpdate();
    }
  }

  shouldComponentUpdate() {
    return true;
  }

  render() {
    /* if (this.props.meta.pristine) {
            this.props.meta.valid = false;
        }

        if (this.props.isrequired == false) {
            this.props.meta.valid = true;
        }
         */
    this.props.meta.valid = false;

    let trySubmit = this.props.checkValidation ? true : false;

    const {
      meta: { touched, error, warning }
    } = this.props;

    let lValue = this.props.input.value;

    return (
      <TextField
        onKeyPress={(e) =>
          this.props.handleKeyPress ? this.props.handleKeyPress(e) : {}
        }
        onChange={this.handleChange}
        id={this.props.input.name}
        value={lValue}
        label={this.props.label}
        className={this.props.classes.textField}
        margin="normal"
        error={
          error && error.length > 0 && touched
            ? true
            : error && error.length > 0 && trySubmit
            ? true
            : false
        }
        helperText={
          (error && error.length > 0 && touched) ||
          (error && error.length > 0 && trySubmit)
            ? error
            : null
        }
        type={this.props.showPassword ? "text" : "password"}
        InputProps={
          this.props.showPassword !== undefined
            ? {
                endAdornment: (
                  <InputAdornment variant="filled" position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.props.handleClickShowPassword}
                    >
                      {this.props.showPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }
            : {}
        }
      />
    );
  }
}

export default withStyles(styles)(FormInputClass);



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/FormInputPassword.js